// extracted by mini-css-extract-plugin
var _1 = "ClientNoteFormDialog_actions__HTBvv";
var _2 = "ClientNoteFormDialog_container__Tzp9+";
var _3 = "ClientNoteFormDialog_content__7tL4+";
export { _1 as "actions", _2 as "container", _3 as "content" }
